<script>
    export default {
        methods: {
            submit(){
                let url = '/save-search';
                this.axios.post(url, this.data).then(response => {
                    if (response && response.data) {
                        //Search is saved
                    }
                }).catch(error => {
                    console.warn("error is submitting form");
                });
                return false;
            },
            generateNameString(name, ...args){
                let name_string = name;
                this.$_.each(args, item => {
                    name_string = name_string + '[' + item + ']';
                });
                return name_string;
            },
            /**
             * Only give the field a name if the value is populated
             * @param fieldname
             * @param value
             */
            getNameField(fieldname, value){
                /**
                 * Check if its in the data obj
                 */
                if (this.data[fieldname]) {
                    return fieldname;
                }
                if (!this.$_.isEmpty(value)) {
                    return fieldname;
                }
                return '';
            },
            objectToString(object){
                let array = [];
                for (const key of Object.keys(object)) {
                    if(object[key]){
                        array.push(key);
                    }
                }
                return array.join();
            },
            counterChecked(checked, date, counter){
                if (checked) {
                    if (!this.data.auction_house_dates[date]) {
                        this.data.auction_house_dates[date] = [];
                    }
                    this.data.auction_house_dates[date].push(counter.auction_house);
                } else {
                    if (this.data.auction_house_dates[date]) {
                        this.data.auction_house_dates[date] =
                            this.$_.without(this.data.auction_house_dates[date], counter.auction_house);
                        if (!this.data.auction_house_dates[date].length) {
                            delete this.data.auction_house_dates[date];
                        }
                    }

                }
            },
            getName(name, value){
                if (value) {
                    return name;
                }
                return '';
            },
            counterTotal:function(counters){
                let total = 0;
                for(var i = 0; i < counters.length; i++){
                    total += parseInt(counters[i].count);
                }
                return total;
            },
            convertDateIntoDayName(data){
                return window.moment(data).format('dddd')
            },
            openAuctionDate(date,event){

                $(event.target.tagName).parents('li.item-list-day').find('#list-auction-'+date).toggle();
                $('.list-auctions').not($(event.target.tagName).parents('li.item-list-day').find('#list-auction-'+date)).hide();

            },
            selectAll(date,event){
                if(this.dates[date]===true){
                    $(event.target.tagName).parents('li.item-list-day').find('#list-auction-'+date).find('input[type="checkbox"]').each((n,elem) => {

                        let auctionHouse = $(elem).val();
                        let dataAuction = auctionHouse+'-'+date;

                        if(jQuery.type(this.auctions[dataAuction])==='undefined' || this.auctions[dataAuction]===false){
                            this.auctions[dataAuction] = true;
                        }
                    });

                }else{
                    $(event.target.tagName).parents('li.item-list-day').find('#list-auction-'+date).find('input[type="checkbox"]').each((n,elem) => {
                        let auctionHouse = $(elem).val();
                        let dataAuction = auctionHouse + '-' + date;

                        this.auctions[dataAuction] = false;
                    });

                }
            },
            onHideModelModal(){
                this.excludedMakes = {};
            },
            onHideExcludeMakesModal(){
                this.selectedModels = {};
                this.data.make = '';
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/mixins/VehicleSearch.vue